import { useEffect, useState } from "react";
import {
  Container,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Typography,
  Button,
  Chip,
  TableContainer,
  Box,
} from "@mui/material";
import api from "../api/axios";
const statusColor = (status) => {
  switch (status) {
    case "paid":
      return "success";
    case "pending":
      return "warning";
    case "failed":
      return "error";
    default:
      return "default";
  }
};

export default function Orders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders").then((res) => setOrders(res.data));
  }, []);

  return (
    <Container maxWidth="xl">
      <Typography variant="h4" fontWeight={600} gutterBottom>
        Orders & Payments
      </Typography>

      <Paper elevation={3} sx={{ borderRadius: 2 }}>
        <TableContainer>
          <Table>
            <TableHead
              sx={{
                background: "#111827",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <TableRow>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Customer</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Service</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Product / Plan</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Amount</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>Status</b>
                </TableCell>
                <TableCell sx={{ color: "#ffffff" }}>
                  <b>PayPal</b>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {orders.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Box textAlign="center" py={4}>
                      <Typography color="text.secondary">
                        No orders found
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}

              {orders.map((o) => (
                <TableRow key={o.id} hover>
                  <TableCell>{o.name}</TableCell>

                  <TableCell>{o.service?.name || "—"}</TableCell>

                  <TableCell>
                    {o.product?.name || o.plan?.name || "—"}
                  </TableCell>

                  <TableCell>£{Number(o.amount).toFixed(2)}</TableCell>

                  <TableCell>
                    <Chip
                      label={o.status}
                      color={statusColor(o.status)}
                      size="small"
                      sx={{ textTransform: "capitalize" }}
                    />
                  </TableCell>

                  <TableCell>
                    {o.paypal_order_id ? (
                      <Button
                        size="small"
                        variant="outlined"
                        href={`https://www.sandbox.paypal.com/activity/payment/${o.paypal_order_id}`}
                        target="_blank"
                      >
                        View
                      </Button>
                    ) : (
                      "—"
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  );
}
